<template>
  <div class="d-flex justify-content-center align-items-center body-content confirmation-wrapper">
    <div class="text-center confirmation-content">
      <p class="font-28 mb-8 fw-bold">
        認証が完了しました！
      </p>
      <p class="font-16 mb-4 fw-bold">
        Bloomキャリア登録を利用する<br />
        大手企業各社へ追加登録が可能です
      </p>
      <button
        class="btn btn-cstm btn-cstm-primary mt-2 h-auto py-2"
        @click="handleOkClick"
        :style="buttonStyle"
      >
        次へ（登録可能企業を表示）
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmationPage',
  props: {
    buttonStyle: {
      type: Object,
      default: () => ({
        background: 'red',
        'border-color': 'red'
      })
    }
  },
  methods: {
    handleOkClick() {
      this.$emit('ok-clicked');
    }
  }
};
</script>

<style scoped>
.confirmation-wrapper {
  min-height: 100vh;
}

.confirmation-content {
  max-width: 500px;
  width: 100%;
}

.btn-cstm {
  padding: 15px 20px;
  width: 100%;
  max-width: 318px;
  border-radius: 3px;
  height: 48px !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 900;
  color: #fff !important;
  background-color: #076d6c !important;
  border-color: #076d6c !important;
}

.font-28 {
  font-size: 24px;
}

.font-18 {
  font-size: 18px;
}

.font-16 {
  font-size: 16px;
}

.mb-6 {
  margin-bottom: 3rem !important;
}

.mb-8 {
  margin-bottom: 1.5rem !important;
}

.font-16 {
  margin-bottom: 2rem !important;
}

@media (max-width: 768px) {
  .font-28 {
    margin-bottom: 2.5rem !important;
  }

  .btn-cstm {
    margin-top: 0 !important;
  }
}
</style> 